import Reveal from "@/components/base/Reveal";

export default function EditorialBanner() {
  return (
    <section className="relative w-full overflow-hidden" aria-label="Editorial Amora Belle">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20an%20elegant%20Brazilian%20woman%20in%20a%20refined%20feminine%20look%20with%20warm%20plum%20and%20beige%20tones%2C%20standing%20in%20a%20sunlit%20Brazilian%20urban%20interior%20with%20soft%20neutral%20walls%2C%20natural%20daylight%2C%20realistic%20skin%20texture%2C%20welcoming%20mood&width=1600&height=900&seq=amora-banner-editorial-01&orientation=landscape"
          alt="Mulher brasileira com look elegante e natural em cenário urbano iluminado"
          title="Elegância que acompanha a vida real — Amora Belle"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/75 via-foreground-950/45 to-foreground-950/20" />
      </div>

      <div className="relative z-10 flex min-h-[420px] w-full items-center px-4 py-16 md:px-8 md:py-20">
        <Reveal className="mx-auto w-full max-w-6xl">
          <div className="max-w-xl">
            <span className="text-[11px] uppercase tracking-[0.28em] text-secondary-300">Editorial Amora Belle</span>
            <h2 className="mt-4 font-heading text-3xl font-medium leading-tight text-background-50 md:text-5xl">
              Elegância que acompanha a vida real
            </h2>
            <p className="mt-5 text-sm leading-relaxed text-background-100 md:text-base">
              Do trabalho ao encontro especial, descubra peças pensadas para deixar sua rotina mais bonita, confortável e
              cheia de personalidade.
            </p>
            <a
              href="#selecao"
              className="mt-8 inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-7 py-3.5 text-sm font-medium text-foreground-900 transition-colors hover:bg-accent-100"
            >
              Descobrir a coleção
              <i className="ri-arrow-right-line text-base" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}